import TopNavigation from '@cloudscape-design/components/top-navigation';
import logoSrc from '../assets/logo-small-top-navigation.svg';
import { useNavigate } from 'react-router-dom';
import useUserProfile from 'src/hooks/useUserProfile';
import { getFromLocalStorage, saveToLocalStorage } from 'src/utils/localStorageUtils';
import { LOCAL_STORAGE_KEYS, ROLES_LABELS } from 'src/contstant/commonLabels';
import { TimezoneType } from 'src/utils/generalUtils';

interface AppHeaderProps {
  onProfileSettingsOpen: () => void;
}
const AppHeader = ({ onProfileSettingsOpen }: AppHeaderProps) => {
  const { getUserName, getUserEmail, getUserId, getPersona } = useUserProfile();
  const navigate = useNavigate();

  return (
    <div data-testid="app-header" id="topnav" className="app-header">
      <TopNavigation
        data-testid="top-navigation"
        identity={{
          href: '#',
          title: 'Gravion',
          logo: {
            src: logoSrc,
            alt: 'Gravion ',
          },
        }}
        utilities={[
          {
            type: 'menu-dropdown',
            iconName: 'globe',
            text: `${getFromLocalStorage<string>(LOCAL_STORAGE_KEYS.TIME_ZONE, TimezoneType.SYSTEM)}`,
            onItemClick: ({ detail }) => {
              if (detail.id === 'utc') {
                saveToLocalStorage<string>(
                  LOCAL_STORAGE_KEYS.TIME_ZONE,
                  TimezoneType.UTC,
                );
              } else if (detail.id === 'system') {
                saveToLocalStorage<string>(
                  LOCAL_STORAGE_KEYS.TIME_ZONE,
                  TimezoneType.SYSTEM,
                );
              }
              // Force refresh
              window.location.reload();
            },
            items: [
              {
                id: 'utc',
                text: 'UTC',
              },
              {
                id: 'system',
                text: 'Local',
              },
            ],
          },
          {
            type: 'menu-dropdown',
            iconName: 'support',
            title: 'Help',
            text: 'Help',

            items: [
              {
                id: 'link1',
                text: 'Request a Gravion Feature',
                href: 'https://form.asana.com/?k=UKSwZ-1i4emeR0jf5ddgUA&d=8442528107068',
                external: true,
                externalIconAriaLabel: 'Opens in a new tab',
              },
              {
                id: 'link4',
                text: 'Request a Dashboard Feature',
                href: 'https://form.asana.com/?k=E9Rju1H2ySXQ9Mk3epOryw&d=8442528107068',
                external: true,
                externalIconAriaLabel: 'Opens in a new tab',
              },
              {
                id: 'link2',
                text: 'Report a Bug',
                href: ' https://t.corp.amazon.com/create/templates/c538ed52-0511-423a-a152-3ca6378a3d4e',
                external: true,
                externalIconAriaLabel: 'Opens in a new tab',
              },
              {
                id: 'link3',
                text: 'Join the Conversation',
                href: 'https://amzn-operations.slack.com/archives/C08MG58LBJ5',
                external: true,
                externalIconAriaLabel: 'Opens in a new tab',
              },
            ],
          },

          {
            type: 'menu-dropdown',
            text: getUserName() || getUserId(),
            iconSvg: (
              <div
                data-testid="profile-avatar-container"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                }}
              >
                <img
                  data-testid="profile-avatar"
                  src={`https://badgephotos.corp.amazon.com/?uid=${getUserId()}`}
                  alt="Profile"
                  style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            ),
            onItemClick: ({ detail }) => {
              switch (detail.id) {
                case 'profile':
                  onProfileSettingsOpen();
                  break;
              }
            },
            items: [
              ...(getPersona()
                ? [
                    {
                      id: 'role',
                      text: ROLES_LABELS[getPersona() as keyof typeof ROLES_LABELS],
                    },
                  ]
                : []),
              {
                id: 'profile',
                text: 'Profile Preferences',
                external: false,
              },
            ],
          },
        ]}
      />
    </div>
  );
};

export default AppHeader;
